import { api } from '@/lib/api';

/** What the API tells the frontend about the signed-in person (login and /api/auth/me). */
export interface UserProfile {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    roleCode: string | null;
    /** What the role allows, by name ("ManageUsers", ...). The server enforces; this only decides what to show. */
    permissions: string[];
}

export const authApi = {
    me: () => api<UserProfile>('/api/auth/me', { expectsSession: false }),

    login: (email: string, password: string) =>
        api<UserProfile>('/api/auth/login', {
            method: 'POST',
            body: { email, password },
            expectsSession: false,
        }),

    logout: () => api('/api/auth/logout', { method: 'POST', expectsSession: false }),

    /** Always 202: the API never says whether the address has an account. */
    requestPasswordReset: (email: string) =>
        api('/api/auth/password/reset-request', {
            method: 'POST',
            body: { email },
            expectsSession: false,
        }),

    resetPassword: (token: string, newPassword: string) =>
        api('/api/auth/password/reset', {
            method: 'POST',
            body: { token, newPassword },
            expectsSession: false,
        }),
};
